import React, { useState, useEffect } from 'react';
import styles from './NavBar.module.css';
declare global {
    interface Window { welcomeRef: any; }
}

function NavBar() {
    const [showTitle, setShowTitle] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);

    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (typeof window !== 'undefined' && window.welcomeRef && window.welcomeRef.current && entry.target === window.welcomeRef.current) {
                    setShowTitle(!entry.isIntersecting);
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1,
            }
        );


        if (typeof window !== 'undefined' && window.welcomeRef && window.welcomeRef.current) {
            observer.observe(window.welcomeRef.current);
        }

        return () => {
            if (typeof window !== 'undefined' && window.welcomeRef && window.welcomeRef.current) {
                observer.unobserve(window.welcomeRef.current);
            }
        };
    }, []);


    return (
        <nav className={`${styles.fundo} ${showTitle ? styles.scrolled : ''}`}>
            <div className={styles.container}>
                <div className={styles.titleAndMenuContainer}>
                    {showTitle && (
                        <div className={`${styles.titulo} ${showTitle ? styles.scrolled : ''}`}>
                            Laboratório de Engenharia de Software
                        </div>
                    )}
                    <div className={styles.menuItems}>
                        <div className={styles.hamburger} onClick={toggleMenu} aria-label="Menu">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <div className={`${styles.navList} ${isOpen ? styles.open : ''}`}>
                            <ul>
                                <li><a href="/" className={`${showTitle ? styles.scrolled : ''}`} onClick={closeMenu}>Início</a></li>
                                <li><a href="#about" className={`${showTitle ? styles.scrolled : ''}`} onClick={closeMenu}>Sobre</a></li>
                                <li><a href="#portfolio" className={`${showTitle ? styles.scrolled : ''}`} onClick={closeMenu}>Portfólio</a></li>
                                <li><a href="#participants" className={`${showTitle ? styles.scrolled : ''}`} onClick={closeMenu}>Participantes</a></li>
                                <li><a href="#contact" className={`${showTitle ? styles.scrolled : ''}`} onClick={closeMenu}>Contato</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default NavBar;